var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0149 13.3915C34.6126 11.1866 34.4204 8.08145 32.4385 6.09902C30.2948 3.95475 26.8568 3.89406 24.6424 5.92707V5.64386C24.6424 2.52861 22.1144 0 19 0C15.8856 0 13.3576 2.52861 13.3576 5.64386V5.92707C11.1432 3.90418 7.70516 3.95475 5.56147 6.09902C3.56945 8.09156 3.37733 11.1866 4.9851 13.3915C2.18414 13.7152 0 16.1022 0 18.9949C0 22.1102 2.52794 24.6388 5.64236 24.6388H5.92549L5.57158 24.9928C3.36722 27.1978 3.36722 30.7682 5.57158 32.9731C7.72539 35.1275 11.2038 35.1781 13.4082 33.0945C13.7722 35.8557 16.1384 38 19 38C21.8616 38 24.2278 35.8658 24.5918 33.0945C26.8063 35.168 30.2746 35.1275 32.4284 32.9731C34.6328 30.7682 34.6328 27.1978 32.4284 24.9928L32.0745 24.6388H32.3576C35.4721 24.6388 38 22.1102 38 18.9949C37.9899 16.1022 35.8159 13.7152 33.0149 13.3915Z",
    fill: "#24EF81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSelected);
export default __webpack_public_path__ + "static/media/calendar_selected.b9a29a37c3084425ebf3421cf8a5fb4d.svg";
export { ForwardRef as ReactComponent };